import axios from 'axios';
import { endpoints } from './endpoints';
import {
  getApiTokensInLocalStorage,
  removeApiTokensInLocalStorage,
  setApiTokensInLocalStorage,
} from '../localStorage/localStorage';
import { history } from '../../Router';
import config from '../../config/config';

const apiBaseUrl = config.serverBasePath;
const networkTimeout = config.networkTimeout;

const defaultUrlParams = {
  //appVersion: Deviceinfo.getVersion(),
  //platform: Platform.OS,
};

declare module 'axios' {
  export interface AxiosRequestConfig {
    hideLoader?: boolean;
  }
}

//per le chiamate api non protette da token
const axiosApiInstancePublic = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  timeout: networkTimeout,
});

axiosApiInstancePublic.interceptors.request.use(
  async (config) => {
    config.params = { ...config.params, ...defaultUrlParams };

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axiosApiInstancePublic.interceptors.response.use(
  (response) => {
    return response;
  },

  async (err) => {
    return Promise.reject(err);
  }
);

//per le chiamate api protette da token
const axiosApiInstancePrivate = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  timeout: networkTimeout,
});

// Request interceptor for API calls
axiosApiInstancePrivate.interceptors.request.use(
  async (config) => {
    const accessToken = getApiTokensInLocalStorage()?.access;

    if (accessToken && config) {
      config.headers.Authorization = 'Bearer ' + accessToken.token;
    }

    config.params = { ...config.params, ...defaultUrlParams };

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Response interceptor for API calls
axiosApiInstancePrivate.interceptors.response.use(
  (response) => {
    return response;
  },

  async (err) => {
    const originalConfig = err.config;

    if (
      originalConfig.url === endpoints.auth.refreshTokens &&
      err.response &&
      err.response.status === 401
    ) {
      //Refresh Token was expired
      removeApiTokensInLocalStorage();
      if (history?.navigate) {
        await history.navigate('/login');
      }
    }

    if (
      originalConfig.url !== endpoints.auth.login &&
      originalConfig.url !== endpoints.auth.refreshTokens &&
      err.response
    ) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;
        try {
          const refreshToken = getApiTokensInLocalStorage()?.refresh;

          const rs = await axiosApiInstancePrivate.post(
            endpoints.auth.refreshTokens,
            {
              refreshToken: refreshToken?.token,
            }
          );
          const tokens = rs.data;
          await setApiTokensInLocalStorage(tokens);
          return axiosApiInstancePrivate(originalConfig);
        } catch (_error) {
          return Promise.reject(_error);
        }
      }
    }

    return Promise.reject(err);
  }
);

export { axiosApiInstancePrivate, axiosApiInstancePublic };
